import type { BaseAppProps } from '@shared/common/app/domain/type/base-app-props.type';
import { ContainerModule } from 'inversify';
import { container } from '@shared/common/dependency-injection/domain/container';
import type { TrackingProviderConfig } from '@shared/common/tracking/domain/model/tracking-provider-config.model';
import { TrackingDependencyTypes } from '@shared/common/tracking/tracking.dependency-types';
import { INTERNAL_USER_NAME } from '@shared/common/tracking/domain/constant/internal-user.constant';

let trackingContainerModule: ContainerModule | null = null;

export const loadTrackingContainerModule = (appProps: BaseAppProps) => {
  if (trackingContainerModule !== null) {
    return;
  }

  trackingContainerModule = new ContainerModule((options) => {
    options.bind<TrackingProviderConfig>(TrackingDependencyTypes.TrackingProviderConfig).toConstantValue({
      apiHost: appProps.posthogApiHost ?? '',
      uiHost: appProps.posthogUiHost ?? '',
      apiKey: appProps.posthogKey ?? '',
      internalUserName: appProps.trackingInternalUserName ?? INTERNAL_USER_NAME,
    });
  });

  container.load(trackingContainerModule);
};

export { trackingContainerModule };
